import React from "react";
import "./SubstituteSelector.scss";

/**
 * Reusable radio option component
 * @param {string} name - Radio group name
 * @param {string|number} value - Radio option value
 * @param {string|number} checkedValue - Currently selected value
 * @param {function} onChange - Change handler
 * @param {ReactNode} children - Label content
 */
const RadioOption = ({ name, value, checkedValue, onChange, children }) => {
  return (
    <div className="ch-radio">
      <label>
        <input
          type="radio"
          name={name}
          value={value}
          checked={checkedValue === value}
          onChange={(e) => onChange(parseInt(e.target.value))}
        />
        <span>{children}</span>
      </label>
    </div>
  );
};

export default RadioOption;


